import ServiceBus from 'servicestack/service-bus'
import ModalController from 'webmodals/modal.controller'
import Media from 'webutils/media/media'

class EditMediaPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        console.warn('EditMediaPromptController', options);
        $ctrl.bus = new ServiceBus()
        $ctrl.title = options.title || `Edit Media Properties...`;
        $ctrl.subTitle = options.subTitle || options.media.label;

        $ctrl.request = Object.assign({}, options.media);
        $ctrl.media = new Media( Object.assign({}, options.media));
        
        $ctrl.bus.send('QueryMedia.json?Id=' + options.media.id).then(res => {
            Object.assign($ctrl.request, res.data.results[0]);
            Object.assign($ctrl.media, res.data.results[0]);
        });

        console.debug('EditMediaPromptController', options);
    }
    
    submit() {
        const $ctrl = this;
        $ctrl.bus.send('UpdateMedia.json', $ctrl.request).then(res => {
            $ctrl.close({updated:res.data});
        });
    }

    toggle() {
        const $ctrl = this;
        let m = $ctrl.request;
        let url = `${m.active?'Dea':'A'}ctivateMedia/${m.id}.json`;

        $ctrl.bus.send(url).then(res => {
            Object.assign(m, res.data);
            $ctrl.close(res.data);
        });
    }
}

export default EditMediaPromptController;
